import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";
import styles from "./CommonInputValor.module.css";

function formatValueMonetarioGlobal(value) {
  if (!value) return "0,00";
  value = value.replace(/\D/g, "");
  value = (value / 100).toFixed(2) + "";
  value = value.replace(".", ",");
  value = value.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
  return value;
}

function parseFormattedValue(value) {
  return parseFloat(value.replace(/\./g, "").replace(",", "."));
}

function setCursorPosition(input, position) {
  input.setSelectionRange(position, position);
}

/**
 * Input reutilizável para valores monetários e semelhantes
 */
function CommonInputValor({
  label,
  id,
  value,
  onChange,
  required = false,
  disabled = false,
  tag = "R$",
  ...props
}) {
  const inputRef = useRef(null);

  useEffect(() => {
    const input = inputRef.current;

    const handleInput = () => {
      const formattedValue = formatValueMonetarioGlobal(input.value);
      input.value = formattedValue;
      const decimalValue = parseFormattedValue(formattedValue);
      onChange({ target: { value: decimalValue } });
    };

    const handleFocus = () => {
      setTimeout(() => {
        input.value = input.value || "0,00";
        const position = input.value.indexOf(",");
        setCursorPosition(input, position);
      }, 0);
    };

    const handleClick = () => {
      const position = input.value.length;
      setCursorPosition(input, position);
    };

    input.addEventListener("input", handleInput);
    input.addEventListener("focus", handleFocus);
    input.addEventListener("click", handleClick);

    return () => {
      input.removeEventListener("input", handleInput);
      input.removeEventListener("focus", handleFocus);
      input.removeEventListener("click", handleClick);
    };
  }, [onChange]);

  useEffect(() => {
    const input = inputRef.current;
    if (value !== parseFormattedValue(input.value)) {
      input.value = formatValueMonetarioGlobal(
        value
          ? typeof value === "string"
            ? !isNaN(parseFloat(value))
              ? parseFloat(value).toFixed(2).toString()
              : "0.00"
            : value.toFixed(2).toString()
          : "0.00"
      );
    }
  }, [value]);

  return (
    <>
      {label && (
        <>
          <label htmlFor={id} className={styles.label}>
            {label}
          </label>
          {required && <span style={{ color: "#f46a6a" }}> *</span>}
        </>
      )}
      <div className={styles.inputGroup}>
        {tag ? <div className={styles.inputGroupText}>{tag}</div> : null}
        <input
          ref={inputRef}
          name={id}
          id={id}
          className={`${styles.input} ${tag && styles.groupInput}`}
          placeholder="0,00"
          defaultValue={formatValueMonetarioGlobal(
            value
              ? typeof value === "string"
                ? !isNaN(parseFloat(value))
                  ? parseFloat(value).toFixed(2).toString()
                  : "0.00"
                : value.toFixed(2).toString()
              : "0.00"
          )}
          onChange={disabled ? null : onChange}
          disabled={disabled}
          {...props}
        />
      </div>
    </>
  );
}

CommonInputValor.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  tag: PropTypes.string,
};

export default CommonInputValor;
